module.exports = __webpack_public_path__ + "static/img/9.28c7e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/9.png
// module id = 5QJI
// module chunks = 0